module.exports = __webpack_public_path__ + "static/00-37a3e748845daaa4ec5ff8a268077056.png";